import {
  AllowTimeEditInMainPickerEntities,
  ClientSideDatesServerFilteredEntities,
  EntitiesWithAdminMode,
  EntitiesWithoutBulkActions,
  EntitiesWithoutBulkDeleteAction,
  EntitiesWithoutGenericUpload,
  RideCrudModeKey,
  RideEntities,
  ServerFilteredEntities,
  ServerGridTextSearchEntities,
  ServerPaginatedEntities,
  ServerPaginatedEntitiesWithGrouping,
  ServerSearchEntities,
} from "../constants";
import { RydeUiUnit } from "../models";
import { ProfileStorage } from "./browser-storge";
import { Log } from "./log.helpers";

export const isEntityServerSideFiltered = (entity: RydeUiUnit): boolean => {
  return ServerFilteredEntities.includes(entity);
};

export const isEntityClientSideWithServerDatesFiltered = (
  entity: RydeUiUnit,
): boolean => {
  return ClientSideDatesServerFilteredEntities.includes(entity);
};

export const isEntityServerSidePaginated = (entity: RydeUiUnit): boolean => {
  return ServerPaginatedEntities.includes(entity);
};

export const isEntityServerGroupedPagination = (entity: RydeUiUnit): boolean =>
  ServerPaginatedEntitiesWithGrouping.includes(entity);

export const isEntityServerSideSearchable = (entity: RydeUiUnit): boolean => {
  return ServerSearchEntities.includes(entity);
};

export const isEntityServerGridTextSearchable = (
  entity: RydeUiUnit,
): boolean => {
  return ServerGridTextSearchEntities.includes(entity);
};

export const isEntityAllowTimeEditInMainPicker = (
  entity: RydeUiUnit,
): boolean => {
  return AllowTimeEditInMainPickerEntities.includes(entity);
};

export const isEntityWithoutBulkActions = (entity: RydeUiUnit): boolean => {
  return EntitiesWithoutBulkActions.includes(entity);
};

export const isEntityWithoutBulkDeleteAction = (
  entity: RydeUiUnit,
): boolean => {
  return EntitiesWithoutBulkDeleteAction.includes(entity);
};

export const isEntityWithoutGenericUpload = (entity: RydeUiUnit): boolean => {
  return EntitiesWithoutGenericUpload.includes(entity);
};

export const isEntityWithAdminMode = (entity: RydeUiUnit): boolean => {
  return EntitiesWithAdminMode.includes(entity);
};

export const isRideEntity = (entity: RydeUiUnit): boolean => {
  return RideEntities.includes(entity);
};

export const normalizeRideEntity = (entity: RydeUiUnit): RydeUiUnit => {
  /* In the ride edit panel, we consistently use 'ride' as the entity within the CRUD form context.
  This guarantees seamless integration with the plus button across various page */
  return entity && isRideEntity(entity) ? entity : RideCrudModeKey.uiUnit;
};

/*
this method is intended to be used outside of components or hooks, where
can't be used value from recoil: const companyId = get(companyIdSelector);
 */
export const getCompanyId = (): number | undefined => {
  const companyId = ProfileStorage.authSet?.companyId ?? undefined;

  if (!companyId) {
    Log.info("No company id found in storage");
  }

  return companyId;
};

export const getNumberWithoutPx = (valueWithPx: string): number => {
  const numberWithoutPx = String(valueWithPx).match(/\d+/);

  if (numberWithoutPx === null) {
    Log.error("Wrong number with Px");
    return 0;
  }

  return Number(numberWithoutPx[0]) as number;
};

export const isValueNumberCompatible = (value: unknown): boolean =>
  Boolean(value) && !!Number(value) && Number(value) !== 0;
